var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inspection-detail-modal" },
    [
      _c(
        "HKLModal",
        {
          ref: "modal",
          attrs: {
            title: _vm.modalTitle,
            closable: true,
            size: "large",
            dialogStyle: {
              "padding-top": "40px",
              "margin-top": "0%",
              top: "0px",
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "inspection-detail-modal__content" },
            [
              _c("div", { staticClass: "edit-form row" }, [
                _c(
                  "div",
                  { staticClass: "column small-6" },
                  [
                    _c("label", { class: { "required-flag": _vm.canEdit } }, [
                      _vm._v(_vm._s(_vm.$t("tenantProjects.inspection.type"))),
                    ]),
                    _vm._v(" "),
                    _vm.canEdit
                      ? _c("HKLSelect", {
                          attrs: {
                            value: _vm.inspection.type || undefined,
                            options: _vm.typeHklOptions,
                            required: true,
                            showSearch: true,
                            placeholder: "",
                          },
                          on: {
                            change: function (val) {
                              _vm.inspection.type = val
                            },
                          },
                        })
                      : _c("span", [
                          _vm._v(
                            _vm._s(_vm.customInsType(_vm.inspection.type))
                          ),
                        ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column small-6" },
                  [
                    _c("label", { class: { "required-flag": _vm.canEdit } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("tenantProjects.inspection.itemInspection")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.canEdit
                      ? _c("HKLSelect", {
                          attrs: {
                            value: _vm.inspection.itemInspection || undefined,
                            options: _vm.itemInspectionHklOptions,
                            required: true,
                            showSearch: true,
                            placeholder: "",
                          },
                          on: {
                            change: function (val) {
                              _vm.inspection.itemInspection = val
                            },
                          },
                        })
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.itemInspectionOptionLabels(
                                _vm.inspection.itemInspection
                              )
                            )
                          ),
                        ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isSelectedOther
                  ? _c(
                      "div",
                      { staticClass: "column small-12" },
                      [
                        _c(
                          "label",
                          {
                            class: [
                              { "required-flag": _vm.canEdit },
                              "additional-hint",
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "tenantProjects.inspection.additionalInfoLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.canEdit
                          ? _c("TextField", {
                              attrs: {
                                showColon: false,
                                value: _vm.inspection.additionalInfo,
                                dirtyCheck: false,
                                required: true,
                              },
                              on: {
                                updateValue: function (val) {
                                  return (_vm.inspection.additionalInfo = val)
                                },
                              },
                            })
                          : _c("div", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("isEmptyValue")(
                                      _vm.inspection.additionalInfo
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column small-12" },
                  [
                    _c("label", { class: { "required-flag": _vm.canEdit } }, [
                      _vm._v(
                        _vm._s(_vm.$t("tenantProjects.inspection.descOfWork"))
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.canEdit
                      ? _c("TextField", {
                          attrs: {
                            showColon: false,
                            value: _vm.inspection.descOfWork,
                            dirtyCheck: false,
                            required: true,
                          },
                          on: {
                            updateValue: function (val) {
                              return (_vm.inspection.descOfWork = val)
                            },
                          },
                        })
                      : _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("isEmptyValue")(
                                  _vm.inspection.descOfWork
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column small-6" },
                  [
                    _c("label", { class: { "required-flag": _vm.canEdit } }, [
                      _vm._v(
                        _vm._s(_vm.$t("tenantProjects.inspection.dateTime"))
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.canEdit
                      ? _c("DateTimeSelector", {
                          attrs: {
                            date: _vm.inspection.date,
                            timeOptions: _vm.timeOptions,
                            showClearBtn: true,
                            required: true,
                          },
                          on: {
                            updateDate: function (val) {
                              return (_vm.inspection.date = val)
                            },
                          },
                        })
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.inspection.date,
                                "DD MMM YY HH:mm"
                              )
                            )
                          ),
                        ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column small-12" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("tenantProjects.inspection.remarks"))
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.canEdit
                      ? _c("TextField", {
                          attrs: {
                            showColon: false,
                            value: _vm.inspection.remarks,
                            dirtyCheck: false,
                          },
                          on: {
                            updateValue: function (val) {
                              return (_vm.inspection.remarks = val)
                            },
                          },
                        })
                      : _c("pre", [
                          _vm._v(
                            _vm._s(
                              _vm._f("isEmptyValue")(_vm.inspection.remarks)
                            )
                          ),
                        ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column small-4" },
                  [
                    _c("label", { class: { "required-flag": _vm.canEdit } }, [
                      _vm._v(
                        _vm._s(_vm.$t("tenantProjects.inspection.handledBy"))
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.canEdit
                      ? _c("InputField", {
                          attrs: {
                            showColon: false,
                            showFlag: false,
                            value: _vm.inspection.handledBy,
                            required: true,
                            dirtyCheck: false,
                          },
                          on: {
                            updateValue: function (val) {
                              return (_vm.inspection.handledBy = val)
                            },
                          },
                        })
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("isEmptyValue")(_vm.inspection.handledBy)
                            )
                          ),
                        ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column small-12 upload-area" },
                  [
                    _c("InspectionAttachments", {
                      attrs: { mailHistories: _vm.mailHistories },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("HKLTable", {
                staticClass: "inspection__history-table",
                attrs: {
                  dataSource: _vm.mailHistories,
                  columns: _vm.mailHistoryCols,
                },
              }),
              _vm._v(" "),
              _vm.lastUpdatedText
                ? _c("div", { staticClass: "last-update" }, [
                    _c("div", { staticClass: "last-update__text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.lastUpdatedText) +
                          "\n        "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.canEdit
                ? [
                    _c("HKLButton", {
                      attrs: { color: "darkblue", action: "cancel" },
                      on: {
                        click: function () {
                          return _vm.close()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("HKLButton", {
                      attrs: { color: "darkblue", action: "save" },
                      on: { click: _vm.saveAction },
                    }),
                    _vm._v(" "),
                    _c("HKLButton", {
                      attrs: { color: "orange", action: "send" },
                      on: { click: _vm.send },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c("InspectionSendModal", {
        ref: "sendModal",
        attrs: { afterClose: _vm.closeSendPopUp },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }